// extracted by mini-css-extract-plugin
module.exports = {"wrapper_handle":"Handler_wrapper_handle__2TpgB","titleHendler":"Handler_titleHendler__29DFI","titleHendlerMonth":"Handler_titleHendlerMonth__37-AP"};